import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

export default function VideoSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.vid-head', { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: 'power4.out', scrollTrigger: { trigger: ref.current, start: 'top 65%' } });
      gsap.fromTo('.vid-wrapper', { opacity: 0, y: 40, scale: 0.96 },
        { opacity: 1, y: 0, scale: 1, duration: 1, delay: 0.15, ease: 'power4.out', scrollTrigger: { trigger: ref.current, start: 'top 60%' } });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec vid-sec" ref={ref}>
      <div className="container">
        <div className="vid-head">
          <span className="pill">CONTOH TEKNIK DARI BUKU TLP</span>
          <h2>Tengok sendiri <span className="gold-grad">hasilnya</span></h2>
          <p className="vid-sub">Teknik yang diajar dalam buku TLP bukan teori — ini bukti sebenar dari pasaran live.</p>
        </div>
        <div className="vid-wrapper">
          <div className="vid-frame">
            <iframe
              src="https://www.youtube.com/embed/yhU7R0DNKbY?rel=0&modestbranding=1"
              title="Contoh Teknik Buku TLP"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <p className="vid-caption">
            Rahsia trader berjaya Adam Danish — semua didedahkan dalam Buku TLP.
          </p>
        </div>
      </div>
    </section>
  );
}
